import { AppConstants, inActiveService, Interfaces, Models } from "@/core/Export";
import store from "@/store";
import "whatwg-fetch";

class ApiService {
  constructor() { }


  public getPortalMissingEvents() {
    let request = new Models.ServiceRequest()
    request.addServiceCall('getPortalMissingEvents', {})
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  public getEmployeePortalMin(employeeId: number, date: any, year: number, month: number) {
    let request = new Models.ServiceRequest()
    request.addServiceCall('getEmployeePortalMin', { employeeId: employeeId, date: date, year: year, month: month });
    return this.sendRequest("servicecall", AppConstants.HttpMethods.Post, request);
  }

  public saveAttendMultipleReport(fromDate, toDate, employeesIds, lines, useOneLineForAllDates, sourceCode) {
    let request = new Models.ServiceRequest()
    request.addServiceCall('saveAttendMultipleReport', { fromDate: fromDate, toDate: toDate, options: { employeeIds: employeesIds }, lines: lines, useOneLineForAllDates: useOneLineForAllDates, sourceCode: sourceCode })
    return this.sendRequest("servicecall", AppConstants.HttpMethods.Post, request);
  }

  public getAttendMultipleReport(fromDate, toDate, employeesIds) {
    let request = new Models.ServiceRequest()
    request.addServiceCall('getAttendMultipleReport', { fromDate: fromDate, toDate: toDate, options: { employeeIds: employeesIds } })
    return this.sendRequest("servicecall", AppConstants.HttpMethods.Post, request);
  }

  validateLoginUserByAccessToken(accessToken: string) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("validateLoginUserByAccessToken", { accessToken: accessToken });
    return this.sendRequest("servicecall", AppConstants.HttpMethods.Post, request);
  }

  getUserInfoAdditionalJob(employeeId: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getUserInfoAdditionalJob", {
      employeeId: employeeId
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getAttendSpecialEvents(employeeId: number, year: number, month: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getAttendSpecialEvents", {
      employeeId: employeeId,
      year: year,
      month: month,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  checkApiUrlByCustomerCode(customerCode: string): Promise<any> {
    return fetch(`${AppConstants.Http.CommonBaseUrl}/checkApiUrlByCustomerCode/${customerCode}`, {
      method: AppConstants.HttpMethods.Get,
      headers: this.appEnv.Headers,
      body: null,
    })
      .then((response) => {
        return response
          .json()
          .then((res) => {
            return Promise.resolve(res);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  public getReportItems() {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getReportItems", {});
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveMultipleEmployeesAttendReportApproval(
    employeeIds: Array<any>,
    year: number,
    month: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveMultipleEmployeesAttendReportApproval", {
      employeeIds: employeeIds,
      year: year,
      month: month,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeAttendMonthMinSummary(
    employeeId: number,
    year: number,
    month: number,
    nominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeAttendMonthBalanceSummary", {
      employeeId: employeeId,
      year: year,
      month: month,
      nominationId: nominationId
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getAttendReportApproval(amrId: number, isManager: boolean) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getAttendReportApproval", {
      amrId: amrId,
      isManager: isManager,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getApprovalsList(employeeId: number, isFromManager: boolean) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getApprovalsList", {
      employeeId: employeeId,
      isFromManager: isFromManager,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveAttendReportApproval(approvalDto: any, isManager: boolean, cancelEmployeeApproval: boolean = false) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveAttendReportApproval", {
      approvalDto: approvalDto,
      isManager: isManager,
      cancelEmployeeApproval: cancelEmployeeApproval
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getFiles(employeeId: number, fileId: number, headers: any) {
    return fetch(
      `${AppConstants.Http.BaseUrl}/getFile/${employeeId}/${fileId}`,
      {
        method: AppConstants.HttpMethods.Post,
        headers: headers,
        body: null,
      }
    )
      .then((response) => {
        if (response.ok) {
          return response;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  getEmployeeFiles(
    employeeId: number,
    year: number,
    month: number,
    day: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeFiles", {
      employeeId: employeeId,
      year: year,
      month: month,
      day: day,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveHealthDeclration(isApproved: boolean) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveHealthDeclration", {
      isApproved: isApproved,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  sendOnPropertyChanged(parameters: Models.onPropertyChangeOptions) {
    return this.post(
      "Forms" + "/" + parameters.entityName + "/" + parameters.id + "/onchange",
      parameters
    );
  }

  userPasswordReset(userName: string, custCode: string) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("userPasswordReset", {
      userId: userName,
      custCode: custCode
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getManagerMonthStatistics(employeeId: number, year: number, month: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getManagerMonthStatistics", {
      employeeId: employeeId,
      year: year,
      month: month,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveEmployeeAttendDayApprove(
    date: string,
    employeeId: number,
    isReject: boolean,
    notes: string,
    year: number,
    month: number,
    salaryFactoryNo: string,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveEmployeeAttendDayApprove", {
      date: date,
      employeeId: employeeId,
      isReject: isReject,
      notes: notes,
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
        employeeNominationId: employeeNominationId
      },
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeAttendDayApprove(
    date: string,
    employeeId: number,
    year: number,
    month: number,
    salaryFactoryNo: string,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeAttendDayApprove", {
      date: date,
      employeeId: employeeId,
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
        employeeNominationId: employeeNominationId
      },
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveEmployeeAttendMonthApprove(
    employeeId: number,
    isReject: boolean,
    year: number,
    month: number,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveEmployeeAttendMonthApprove", {
      employeeId: employeeId,
      isReject: isReject,
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        employeeNominationId: employeeNominationId
      },
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeAttendMonthApprove(
    employeeId: number,
    year: number,
    month: number,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeAttendMonthApprove", {
      employeeId: employeeId,
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        employeeNominationId: employeeNominationId
      },
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }
  getBaseItem(type: string) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getBaseItem", { type: type });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveNewEmployeeAttendMonthEntry(
    employeeId: number,
    year: number,
    month: number,
    salaryFactoryNo: string,
    lines: object
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveNewEmployeeAttendMonthEntry", {
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
      },
      lines: lines,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveMonthlyEmployeeStandby(standByDays: Array<any>) {
    let request = new Models.ServiceRequest();

    request.addServiceCall('saveMonthlyEmployeeStandby', {
      standByDays: standByDays
    })

    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveEmployeeAttendDayEntry(
    employeeId: number,
    year: number,
    month: number,
    salaryFactoryNo: string,
    day: object

  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveEmployeeAttendDayEntry", {
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
      },
      sourceCode: AppConstants.SourceCode.Portal,
      day: day
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeAttendDayEntry(
    employeeId: number,
    year: number,
    month: number,
    salaryFactoryNo: string,
    dayDate: string,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeAttendDayEntry", {
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
        employeeNominationId: employeeNominationId
      },
      dayDate: dayDate,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }


  getNewEmployeeAttendMonthEntry(
    employeeId: number,
    year: number,
    month: number,
    salaryFactoryNo: string,
    employeeNominationId: number
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getNewEmployeeAttendMonthEntry", {
      userSessionData: {
        year: year,
        month: month,
        employeeId: employeeId,
        salaryFactoryNo: salaryFactoryNo,
        employeeNominationId: employeeNominationId
      },
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  userPasswordChangeFromLogin(
    userId: string,
    newUserPassword: string,
    verfiyUserNewPassword: string
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("userPasswordChangeFromLogin", {
      userId: userId,
      newUserPassword: newUserPassword,
      verfiyUserNewPassword: verfiyUserNewPassword,
      hasEmail: true,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  uploadFiles(files, headers) {
    return fetch(AppConstants.Http.BaseUrl + "/uploadFiles", {
      method: AppConstants.HttpMethods.Post,
      headers: headers,
      body: files,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  saveSingle(entityName: string, entity: any, parameters?: any) {
    if (!parameters) parameters = {};
    parameters["entityName"] = entityName;
    parameters["entity"] = entity;
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveSingle", parameters);
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveSingleMissingEvent(
    entityName: string,
    entity: any,
    parameters?: any
  ): Promise<any> {
    if (!parameters) parameters = {};
    parameters["entityName"] = entityName;
    parameters["entity"] = entity;
    parameters["sourceCode"] = AppConstants.AttendEntrySource.Portal;
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveSingle", parameters);
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  public getList(entityName: string, parameters?: any): Promise<any> {
    if (!parameters) parameters = {}
    parameters["entityName"] = entityName;
    let request = new Models.ServiceRequest();
    request.addServiceCall("getList", parameters);
    return this.sendRequest('servicecall', AppConstants.HttpMethods.Post, request);
  }

  getSingle(entityName: string, parameters?: any) {
    if (!parameters) parameters = {};
    parameters["entityName"] = entityName;
    let request = new Models.ServiceRequest();
    request.addServiceCall("getSingle", parameters);
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getReportUrl(key: string, fileExt: string = "pdf", isReportPreparedFile: boolean = false) {
    return this.sendRequest(
      "reports/" + key + "/" + fileExt + '/' + isReportPreparedFile,
      AppConstants.HttpMethods.Get,
      null,
      AppConstants.ResponseTypes.Blob
    );
  }

  getUserReportKey(reportDataTypeCode: string, parametersContent: any) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getUserReportKey", {
      reportDataTypeCode: reportDataTypeCode,
      parametersContent: parametersContent,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeMonthAttend(
    employeeId: number,
    year: number,
    month: number,
    forceCalc: boolean = false,
    salaryFactoryNo: string,
    empNominationId: number,
    versionNo: number = -1
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeMonthAttend", {
      employeeId: employeeId,
      year: year,
      month: month,
      forceCalc: forceCalc,
      salaryFactoryNo: salaryFactoryNo,
      empNominationId: empNominationId,
      versionNo: versionNo,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeStandBy(
    employeeId: number,
    year: number,
    month: number,
  ) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeStandBy", {
      employeeId: employeeId,
      year: year,
      month: month,
      fromEPClient: true
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getManagerEmployees(year: number, month: number, employeeId?: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getManagerEmployees", {
      employeeId: employeeId,
      year: year,
      month: month,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getManagerEmployeesIncludingIndirectEmployees(employeeIds: Array<number>) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getManagerEmployeesIncludingIndirectEmployees", {
      employeeIds: employeeIds,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeDayAdditionalToEditData(additionalId: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeDayAdditionalPortalToEdit", {
      additionalId: additionalId,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeDayAdditionalPortalData(date: string, employeeId: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeDayAdditionalPortalToView", {
      employeeId: employeeId,
      date: date,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  getEmployeeDayAdditionalsReasonsPortalData(employeeId: number) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("getEmployeeDayAdditionalsReasonsPortal", {
      employeeId: employeeId,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  saveEmployeeDayAdditional(employeeId: number, date: any, lines: Array<any>, nominationId: number = 0): Promise<any> {
    let request = new Models.ServiceRequest();
    request.addServiceCall("saveEmployeeAdditionalPortal", {
      employeeId: employeeId,
      date: date,
      lines: lines,
      nominationId: nominationId
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }
  deleteAdditionalPortal(employeeDayAdditionalId) {
    let request = new Models.ServiceRequest();
    request.addServiceCall("deleteAdditionalPortal", {
      employeeDayAdditionalId: employeeDayAdditionalId,
    });
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  public getBudgetItemsDS(fromDate, toDate, employeeId) {
    let request = new Models.ServiceRequest()
    request.addServiceCall('getBudgetItemsDS', { fromDate: fromDate, toDate: toDate, employeeId: employeeId })
    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request
    );
  }

  login(customerCode: string, userName: string, userPassword: string) {
    let request = new Models.ServiceRequest();
    let requestPayload = {
      userId: userName,
      pw: userPassword,
      customerCode: customerCode,
      sourceCode: AppConstants.AttendEntrySource.Portal,
      userMobileAppId: this.appEnv.MobileAppUUID,
      isMobileApp: this.appEnv.IsMobileApp
    };

    request.addServiceCall("login", requestPayload);

    return this.sendRequest(
      "servicecall",
      AppConstants.HttpMethods.Post,
      request,
      AppConstants.ResponseTypes.Json,
      true
    );
  }

  saveForm(entityName: string, id: string, formData: any) {
    return this.post("Forms" + "/" + entityName + "/" + id, formData);
  }

  getForm(entityName: string, id: string) {
    return this.get("Forms" + "/" + entityName + "/" + id);
  }

  getForm_Post(entityName: string, id: string, params?: any) {
    if (!params) params = {};
    return this.post("Forms/get" + "/" + entityName + "/" + id, params);
  }

  delete(path: string, params?: any) {
    return this.sendRequest(path, AppConstants.HttpMethods.Delete, params);
  }

  post(path: string, params?: any) {
    return this.sendRequest(path, AppConstants.HttpMethods.Post, params);
  }

  get(path: string, params?: any) {
    return this.sendRequest(path, AppConstants.HttpMethods.Get, params);
  }

  sendRequest(
    path: string,
    method: string,
    params?: any,
    responseType: string = AppConstants.ResponseTypes.Json,
    isLogin: boolean = false
  ): Promise<any> {
    this.resetTimer(params);
    return fetch(AppConstants.Http.BaseUrl + "/" + path, {
      method: method,
      headers: this.getHeaders(),
      body: params ? JSON.stringify(params) : null,
    })
      .then((response) => {
        if (response.ok) {
          if (responseType == AppConstants.ResponseTypes.Json) {
            return response
              .json()
              .then((res) => {
                let result = res as Interfaces.iServiceRequest;
                let call = result.calls[0] as Interfaces.iServiceCall;
                if (call && !call.isSuccess && !isLogin) {
                  let firstMsg = call.msgs.msgs[0];
                  if (firstMsg && firstMsg.msgCode == "USER_NOT_EXIST") {
                    this.appEnv.logOut();
                  } else {
                    return Promise.resolve(res);
                  }
                } else {
                  return Promise.resolve(res);
                }
              })
              .catch((err) => {
                return Promise.reject(err);
              });
            //return response.json();
          } else if (responseType == AppConstants.ResponseTypes.Blob) {
            return response.blob();
          }
        } else {
          return Promise.reject(response);
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  private resetTimer(request: Models.ServiceRequest) {
    let isServiceRequestType = request instanceof Models.ServiceRequest;
    if (request == null || request == undefined || isServiceRequestType && request.calls[0].methodName != "login") {
      inActiveService.resetTimer();
    }
  }

  public getHeaders() {
    let headers = this.appEnv.Headers;
    headers["clientsessiondata"] = this.clientSessionData;
    return headers;
  }

  public get clientSessionData(): string {
    return JSON.stringify({
      year: store.getters.selectedYear,
      month: store.getters.selectedMonth,
      employeeId: store.getters.currentEmployee && store.getters.currentEmployee.hasOwnProperty("id") ? store.getters.currentEmployee["id"] : 0,
      salaryFactoryNo: '',
      employeeNominationId: store.getters.selectedEmpNominationId
    })
  }

  get appEnv() {
    return store.state.appEnv;
  }
}

export const apiService = new ApiService();
